interface Props {
  message?: string;
}

export function EmptyState({ message = 'NO DATA AVAILABLE' }: Props) {
  return (
    <div className="flex items-center justify-center py-16 text-mono-600 text-sm tracking-wider">
      {message}
    </div>
  );
}
